import { Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const HERO_IMG = "/assets/orchestra-cover.jpg";

export const Hero = () => (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden grain-overlay">
        <img src={HERO_IMG} alt="Allen G. Orchestra — full ensemble in black tie" className="absolute inset-0 w-full h-full object-cover object-[center_75%] md:object-center img-luxe" />
        <div className="absolute inset-0 hero-vignette" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pb-24 md:pb-32 pt-40 w-full">
            <Reveal>
                <p data-testid="hero-overline" className="text-xs md:text-sm uppercase tracking-[0.35em] text-[#d4af37] font-medium mb-6 [text-shadow:0_1px_2px_rgba(0,0,0,0.95),0_0_14px_rgba(0,0,0,0.85)]">
                    Beverly Hills &middot; Los Angeles &middot; Performing Worldwide
                </p>
            </Reveal>
            <Reveal delay={0.15}>
                <h1 data-testid="hero-heading" className="font-serif text-5xl sm:text-6xl tracking-tight font-light text-[#fafafa] max-w-4xl leading-[1.05] [text-shadow:0_2px_18px_rgba(0,0,0,0.7)]">
                    A full live orchestra brings <em className="text-[#d4af37]">energy.</em>
                </h1>
            </Reveal>
            <Reveal delay={0.3}>
                <p data-testid="hero-lede" className="mt-8 text-base sm:text-lg leading-relaxed text-[#d4d4d8] max-w-2xl font-light [text-shadow:0_1px_3px_rgba(0,0,0,0.9),0_0_12px_rgba(0,0,0,0.6)]">
                    Entertainment is the single most important decision you&rsquo;ll make throughout the wedding planning
                    process. Trusted since 2007 with hundreds of weddings played — from an intimate string quartet to a
                    full international orchestra with vocalists.
                </p>
            </Reveal>
            <Reveal delay={0.45}>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <a href="#enquire" data-testid="hero-enquire-btn"
                        className="inline-flex items-center px-8 py-4 text-xs uppercase tracking-[0.25em] bg-[#d4af37] text-[#08080a] hover:bg-[#c6a87c] transition-colors duration-300 glow-gold">
                        Contact Us
                    </a>
                    <a href="tel:+13108770250" data-testid="hero-call-btn"
                        className="inline-flex items-center gap-3 px-8 py-4 text-xs uppercase tracking-[0.25em] border border-white/20 text-[#fafafa] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors duration-300">
                        <Phone size={14} /> 310.877.0250
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
